import React, { FC } from 'react';
import { Container, Stack, Button } from '@mui/material';
import { usePhrase } from '@/hooks';
import { RESPONSE_ERROR_PHRASES } from '@/consts/phrases/errorPhrases';
import { ErrorIcon500 } from '@/assets/theme/default/errorsIcons';
import { ErrorBlock } from '../ErrorBlock/ErrorBlock';

interface Error500Props {
    retryCallback?: () => void;
}

export const Error500: FC<Error500Props> = ({ retryCallback }) => {
    const { t } = usePhrase();

    return (
        <>
            <ErrorBlock
                icon={<ErrorIcon500 />}
                title={t(RESPONSE_ERROR_PHRASES.SOMETHING_WRONG)}
                text={t(RESPONSE_ERROR_PHRASES.SOMETHING_WRONG_DESCRIPTION)}
            />
            {retryCallback && (
                <Container sx={{ mt: -8, mb: 6 }}>
                    <Stack
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Button variant="outlined" color="primary" onClick={retryCallback}>
                            {t(RESPONSE_ERROR_PHRASES.RETRY_BUTTON)}
                        </Button>
                    </Stack>
                </Container>
            )}
        </>
    );
};

export default Error500;
